module.exports = __webpack_public_path__ + "img/tb-05@2x.1dad4f12.png";